import React, { useContext } from 'react';
import Text from 'components/common/Text';
import sideImageEng from 'images/option2_step2_blue_new.svg';
import sideImageHeb from 'images/option2_step2_blue_new_he.png';
import { ContentContainer, FormContainer, HeadlinesContainer, SideImage } from '../style';
import { LabelsContext, ThemeContext } from 'helpers/contexts';
import { TextInput } from 'components/common/Input';
import Button from 'components/common/Button';
import LoadingButton from 'components/common/LoadingButton';
import Icon from 'components/common/Icon';
import * as S from './style';
import * as Constant from 'constant';
import { getLanguageFromQueryParams, LANGUAGES } from 'languages/utils';

function DesktopSecondScreen(props) {
  const { signUp, global } = useContext(LabelsContext);
  const { colors } = useContext(ThemeContext);
  const language = getLanguageFromQueryParams();
  const sideImage = language === LANGUAGES.HE ? sideImageHeb : sideImageEng;

  const handleChipClick = (value) => {
    props.onChipSelection && props.onChipSelection(value);
  };

  const handleBusinessTypeSelect = (value) => {
    props.onBusinessTypeChange && props.onBusinessTypeChange(value);
  };

  return (
    <S.TemplateAndCompanySizePageContainer bgColor={colors.white} data-testid="signupPopup">
      <HeadlinesContainer isRtl={props.isRtl}>
        <SideImage src={sideImage} alt="step-1" />
      </HeadlinesContainer>
      <FormContainer marginTop={'20px'}>
        <ContentContainer>
          <S.IndustryTypeContainer>
            <Text size={Constant.SIZE.xxl} dataTestId="industryType">
              {signUp.templateAndCompanySize.industryType}
            </Text>
            <S.IndustrySelectInputContainer borderColor={colors.gray.gray400}>
              {props.businessTypes.map((businessType) => {
                const isSelected = props.businessType === businessType.value;
                const buttonColor = isSelected ? colors.gray.gray400 : colors.gray.gray200;
                return (
                  <S.BusinessTypeContainer key={businessType.value}>
                    <S.BusinessTypeButton
                      data-testid={businessType.value}
                      data-tid={`signup.secondscreen.businesstemplate.${businessType.value}`}
                      color={buttonColor}
                      hoverColor={isSelected ? undefined : colors.gray.gray300}
                      onClick={() => handleBusinessTypeSelect(businessType.value)}
                      padding={businessType.padding}
                      iconTextMargin={props.shouldShowIcons ? businessType.iconTextMargin : undefined}
                    >
                      {props.shouldShowIcons && <Icon size={Constant.SIZE.xl} color={colors.gray.charcoal} name={businessType.icon}></Icon>}
                      <Text size={Constant.SIZE.xl} color={colors.gray.charcoal}>
                        {businessType.label}
                      </Text>
                    </S.BusinessTypeButton>
                  </S.BusinessTypeContainer>
                );
              })}
            </S.IndustrySelectInputContainer>
            {props.businessTypeError && (
              <S.ErrorContainer bottom={'-10px'}>
                <Text size={Constant.SIZE.xxs} color={colors.red.salmon} dataTestId="industryTypeError">
                  {props.businessTypeError}
                </Text>
              </S.ErrorContainer>
            )}
          </S.IndustryTypeContainer>
          <S.CompanySizeContainer>
            <Text size={Constant.SIZE.xxl} dataTestId="companySize">
              {signUp.templateAndCompanySize.companySize}
            </Text>
            <S.DesktopChipsContainer>
              {props.companySizeOptions.map((option) => {
                return (
                  <S.CompanySizeWrapper key={option.value} data-tid={`signup.secondscreen.companysize.${option.label}`}>
                    <Button
                      size={Constant.SIZE.large}
                      text={option.label}
                      color={Constant.COLOR.light}
                      variant={Constant.VARIENT.outlined}
                      onClick={() => handleChipClick(option.value)}
                      rounded
                      isActive={props.companySize === option.value}
                      dataTestId={option.label}
                    />
                  </S.CompanySizeWrapper>
                );
              })}
            </S.DesktopChipsContainer>
            {props.companySizeError && (
              <S.ErrorContainer bottom={'-15px'}>
                <Text size={Constant.SIZE.xxs} color={colors.red.salmon} dataTestId="companySizeError">
                  {props.companySizeError}
                </Text>
              </S.ErrorContainer>
            )}
          </S.CompanySizeContainer>
          <S.InputContainer>
            <Text size={Constant.SIZE.xxl} dataTestId="companyName">
              {signUp.templateAndCompanySize.companyName}
            </Text>
            <S.InputWrapper borderColor={colors.gray.gray400} data-tid={'signup.secondscreen.companyname'}>
              <TextInput
                size={Constant.SIZE.large}
                width={Constant.FULL_LENGTH}
                value={props.companyName}
                variant={Constant.VARIENT.empty}
                onChange={props.onCompanyNameChange}
                dataTestId="companyNameInput"
              />
            </S.InputWrapper>
            {props.companyNameError && (
              <S.ErrorContainer isRtl={props.isRtl}>
                <Text size={Constant.SIZE.xxs} color={colors.red.salmon} dataTestId="companyNameError">
                  {props.companyNameError}
                </Text>
              </S.ErrorContainer>
            )}
          </S.InputContainer>
          <S.SubmitButtonContainer data-tid={'signup.secondscreen.letsgobutton'}>
            <LoadingButton
              id={'step2'}
              size={Constant.SIZE.xl}
              color={Constant.COLOR.dark}
              onClick={props.onSubmit}
              text={global.letsGo}
              rounded
              isLoading={props.isUpdating}
              width={'128px'}
              dataTestId="letsGo"
            />
          </S.SubmitButtonContainer>
        </ContentContainer>
      </FormContainer>
    </S.TemplateAndCompanySizePageContainer>
  );
}

export default DesktopSecondScreen;
